import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import carImg from 'images/tmp_car_image.png'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'

const MyCarRecall = () => {

	const App = useApp()
	const [carData, setCarData] = useState()
	const [tabList, setTabList] = useState(1)
	const [showLayer, setShowLayer] = useState(false)
	const [showConfirm, setShowConfirm] = useState(false)

	const dataOpen = () => {
		setCarData(!carData)
	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openConfirm = () => {
		setShowConfirm(true)
	}

	const closeConfirm = () => {
		setShowConfirm(false)
	}


	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="flex-justify_end padding pt_0">
					<span onClick={openConfirm} className="link-top" style={{ color: "#999" }}>삭제</span>
				</div>
				<div className="no-scroll" style={{ overflowX: "auto" }}>
					<ul className="tab-round no-wrap">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>123가1234</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>리콜정보</li>
						<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>수리・정비내역</li>
					</ul>
				</div>
				<div className="padding pb_50">
					<div className="img-box" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
						<img src={carImg} alt="" />
					</div>

					<div className="car-info mt_20">
						<div>
							<span>테슬라</span>
							<span>테슬라 모델X</span>
						</div>

						{/* 차량 세부모델명 하나일 때 */}
						<p>조대리님 미래 2058년의 차 테슬라 모델X</p>

						{/* 차량 세부모델명 리스트로 나올 때 */}
						<div className={`${styles["car-name-wrap"]} ${carData ? styles.active : ""}`} onClick={dataOpen}>
							<div className="flex-justify_between align_center">
								<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
								<i className="icon icon_arrow_sm bottom gray" />
							</div>
							<div>
								<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
							</div>
						</div>

						<div className="warn-txt mt_10" onClick={openLayer}>미납 금액이 있어요.</div>
					</div>
				</div>
			</div>

			<div className="padding">
				<h3>내 차 리콜현황</h3>
				<ul className="my-info-box mt_40">
					<li>
						<span>전체</span>
						<span>4건</span>
					</li>
					<li>
						<span>미완료</span>
						<span>2건</span>
					</li>
				</ul>
			</div>
			<ul className="step-area list-bg pb_50 mt_20">
				<li>
					<div>
						<div className="flex-justify_between align_center">
							<span className="date">2020.01.31 ~</span>
							<i className="tag tag-round tag-gray-line">국토부</i>
						</div>
						<div className="txt-area">
							<p className="ellipsis">[벤츠] C 220 CDI등 9차종 - 운전석 및 동반석 에어백 관련 리콜</p>
						</div>
						<span className="circle" />
					</div>
				</li>
				<li>
					<div>
						<div className="flex-justify_between align_center">
							<span className="date">2020.01.31 ~</span>
							<i className="tag tag-round tag-gray-line">환경부</i>
						</div>
						<div className="txt-area">
							<p className="ellipsis">[벤츠] C 220 CDI등 9차종 - 운전석 및 동반석 에어백 관련 리콜</p>
						</div>
						<span className="circle" />
					</div>
				</li>
				<li>
					<div>
						<div className="flex-justify_between align_center">
							<span className="date">2020.01.31 ~ 2020.01.31</span>
							<i className="tag tag-round tag-blue-line">완료</i>
						</div>
						<div className="txt-area">
							<p className="ellipsis">[벤츠] C 220 CDI등 9차종 - 운전</p>
						</div>
						<span className="circle" />
					</div>
				</li>
				<li>
					<div>
						<div className="flex-justify_between align_center">
							<span className="date">2020.01.31 ~ 2020.01.31</span>
							<i className="tag tag-round tag-blue-line">완료</i>
						</div>
						<div className="txt-area">
							<p className="ellipsis">[벤츠] C 220 CDI등 9차종 - 운전</p>
						</div>
						<span className="circle" />
					</div>
				</li>
			</ul>

			{/* 리콜대상이 아닌 경우 */}
			<div className="center-cont padding">
				<i className="icon icon_no_data" />
				<p className="mt_20">내 차는 리콜 대상이 아니에요.</p>
			</div>

			{/* 리콜조회에 실패한 경우 */}
			<div className="center-cont padding">
				<i className="icon icon_no_data" />
				<p className="mt_20">리콜 현황 조회에 실패했어요.<br />다시 조회해보세요.</p>
				<Button className="btn btn--big mt_40">리콜 조회하기</Button>
			</div>


			<NonpaymentLayer show={showLayer} closeLayer={closeLayer} />
			<ConfirmLayer show={showConfirm} closeLayer={closeConfirm} />
		</div>
	)
}

const NonpaymentLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text py_10">
				차량에 현재 고속도로 통행료 미납이 발생했어요.<br />
				한국도로공사 홈페이지에서 상세 정보 확인 및 납부가<br />
				가능해요.
				<div className="mt_10 text-blue flex-align_center" style={{ fontWeight: 500 }}>
					한국도로공사 홈페이지 확인하기 <i className="icon icon_btn_arrow_blue ml_10" />
				</div>
			</div>
		</LayerBottom>
	)
}

const ConfirmLayer = ({ show, closeLayer, onClick }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<div className="btn-group">
				<Button className="btn btn--big btn-layer btn--gray" onClick={() => closeLayer()}>취소</Button>
				<Button className="btn btn--big btn-layer" onClick={onClick}>삭제하기</Button>
			</div>
		}>
			<div className="layer-text py_10">
				등록한 내 차를 삭제하시겠습니까?
			</div>
		</LayerBottom>
	)
}

export default MyCarRecall